import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _dba449e2 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _248aeb70 = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _ae45ad8c = () => interopDefault(import('..\\pages\\have-a-card\\index.vue' /* webpackChunkName: "pages_have-a-card_index" */))
const _0476a268 = () => interopDefault(import('..\\pages\\have-a-card\\enrollment.vue' /* webpackChunkName: "pages_have-a-card_enrollment" */))
const _ed00682a = () => interopDefault(import('..\\pages\\have-a-card\\success.vue' /* webpackChunkName: "pages_have-a-card_success" */))
const _532c097c = () => interopDefault(import('..\\pages\\prescription-information.vue' /* webpackChunkName: "pages_prescription-information" */))
const _4770dd10 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _1298186c = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _90e62b7a = () => interopDefault(import('..\\pages\\thank-you.vue' /* webpackChunkName: "pages_thank-you" */))
const _216e034d = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _1c8e622d = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _63084a70 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _631661f1 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _633290f3 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _6340a874 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _d022f49e = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _7583cfa3 = () => interopDefault(import('..\\pages\\need-a-card\\eligibility.vue' /* webpackChunkName: "pages_need-a-card_eligibility" */))
const _8568e820 = () => interopDefault(import('..\\pages\\need-a-card\\insurance.vue' /* webpackChunkName: "pages_need-a-card_insurance" */))
const _de077162 = () => interopDefault(import('..\\pages\\need-a-card\\insurance-information.vue' /* webpackChunkName: "pages_need-a-card_insurance-information" */))
const _262f460c = () => interopDefault(import('..\\pages\\need-a-card\\patient-information.vue' /* webpackChunkName: "pages_need-a-card_patient-information" */))
const _3d08e7de = () => interopDefault(import('..\\pages\\need-a-card\\prescriber-information.vue' /* webpackChunkName: "pages_need-a-card_prescriber-information" */))
const _54802428 = () => interopDefault(import('..\\pages\\need-a-card\\select-path.vue' /* webpackChunkName: "pages_need-a-card_select-path" */))
const _c2559fce = () => interopDefault(import('..\\pages\\need-a-card\\success.vue' /* webpackChunkName: "pages_need-a-card_success" */))
const _e3ba2150 = () => interopDefault(import('..\\pages\\patient\\i-want-to.vue' /* webpackChunkName: "pages_patient_i-want-to" */))
const _791758c6 = () => interopDefault(import('..\\pages\\patient\\insurance-information.vue' /* webpackChunkName: "pages_patient_insurance-information" */))
const _70457095 = () => interopDefault(import('..\\pages\\patient\\patient-authorization.vue' /* webpackChunkName: "pages_patient_patient-authorization" */))
const _13df03f1 = () => interopDefault(import('..\\pages\\patient\\patientSearch.vue' /* webpackChunkName: "pages_patient_patientSearch" */))
const _013a8632 = () => interopDefault(import('..\\pages\\patient\\success.vue' /* webpackChunkName: "pages_patient_success" */))
const _06045438 = () => interopDefault(import('..\\pages\\patient\\upload-documents.vue' /* webpackChunkName: "pages_patient_upload-documents" */))
const _a9e9d874 = () => interopDefault(import('..\\pages\\provider\\hyrimoz.vue' /* webpackChunkName: "pages_provider_hyrimoz" */))
const _6c49f34b = () => interopDefault(import('..\\pages\\provider\\i-would-like-to.vue' /* webpackChunkName: "pages_provider_i-would-like-to" */))
const _69da8f67 = () => interopDefault(import('..\\pages\\provider\\patient-authorization.vue' /* webpackChunkName: "pages_provider_patient-authorization" */))
const _4b260fa7 = () => interopDefault(import('..\\pages\\provider\\patient-insurance-information.vue' /* webpackChunkName: "pages_provider_patient-insurance-information" */))
const _2a9714ca = () => interopDefault(import('..\\pages\\provider\\prescriber-signature.vue' /* webpackChunkName: "pages_provider_prescriber-signature" */))
const _7eda87b3 = () => interopDefault(import('..\\pages\\provider\\prescription-information.vue' /* webpackChunkName: "pages_provider_prescription-information" */))
const _d68306ec = () => interopDefault(import('..\\pages\\provider\\provider-information.vue' /* webpackChunkName: "pages_provider_provider-information" */))
const _d8c4ee7c = () => interopDefault(import('..\\pages\\provider\\selection.vue' /* webpackChunkName: "pages_provider_selection" */))
const _7fae5339 = () => interopDefault(import('..\\pages\\provider\\success.vue' /* webpackChunkName: "pages_provider_success" */))
const _11a98ac6 = () => interopDefault(import('..\\pages\\provider\\upload-document.vue' /* webpackChunkName: "pages_provider_upload-document" */))
const _1c308bb4 = () => interopDefault(import('..\\pages\\provider\\upload-documents.vue' /* webpackChunkName: "pages_provider_upload-documents" */))
const _4e67bcd9 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _dba449e2,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _248aeb70,
    children: [{
      path: "",
      component: _ae45ad8c,
      name: "have-a-card"
    }, {
      path: "enrollment",
      component: _0476a268,
      name: "have-a-card-enrollment"
    }, {
      path: "success",
      component: _ed00682a,
      name: "have-a-card-success"
    }]
  }, {
    path: "/prescription-information",
    component: _532c097c,
    name: "prescription-information"
  }, {
    path: "/rejection",
    component: _4770dd10,
    name: "rejection"
  }, {
    path: "/success",
    component: _1298186c,
    name: "success"
  }, {
    path: "/thank-you",
    component: _90e62b7a,
    name: "thank-you"
  }, {
    path: "/unlock",
    component: _216e034d,
    name: "unlock"
  }, {
    path: "/upload-documents",
    component: _1c8e622d,
    name: "upload-documents"
  }, {
    path: "/errors/400",
    component: _63084a70,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _631661f1,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _633290f3,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _6340a874,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _d022f49e,
    name: "errors-500"
  }, {
    path: "/need-a-card/eligibility",
    component: _7583cfa3,
    name: "need-a-card-eligibility"
  }, {
    path: "/need-a-card/insurance",
    component: _8568e820,
    name: "need-a-card-insurance"
  }, {
    path: "/need-a-card/insurance-information",
    component: _de077162,
    name: "need-a-card-insurance-information"
  }, {
    path: "/need-a-card/patient-information",
    component: _262f460c,
    name: "need-a-card-patient-information"
  }, {
    path: "/need-a-card/prescriber-information",
    component: _3d08e7de,
    name: "need-a-card-prescriber-information"
  }, {
    path: "/need-a-card/select-path",
    component: _54802428,
    name: "need-a-card-select-path"
  }, {
    path: "/need-a-card/success",
    component: _c2559fce,
    name: "need-a-card-success"
  }, {
    path: "/patient/i-want-to",
    component: _e3ba2150,
    name: "patient-i-want-to"
  }, {
    path: "/patient/insurance-information",
    component: _791758c6,
    name: "patient-insurance-information"
  }, {
    path: "/patient/patient-authorization",
    component: _70457095,
    name: "patient-patient-authorization"
  }, {
    path: "/patient/patientSearch",
    component: _13df03f1,
    name: "patient-patientSearch"
  }, {
    path: "/patient/success",
    component: _013a8632,
    name: "patient-success"
  }, {
    path: "/patient/upload-documents",
    component: _06045438,
    name: "patient-upload-documents"
  }, {
    path: "/provider/hyrimoz",
    component: _a9e9d874,
    name: "provider-hyrimoz"
  }, {
    path: "/provider/i-would-like-to",
    component: _6c49f34b,
    name: "provider-i-would-like-to"
  }, {
    path: "/provider/patient-authorization",
    component: _69da8f67,
    name: "provider-patient-authorization"
  }, {
    path: "/provider/patient-insurance-information",
    component: _4b260fa7,
    name: "provider-patient-insurance-information"
  }, {
    path: "/provider/prescriber-signature",
    component: _2a9714ca,
    name: "provider-prescriber-signature"
  }, {
    path: "/provider/prescription-information",
    component: _7eda87b3,
    name: "provider-prescription-information"
  }, {
    path: "/provider/provider-information",
    component: _d68306ec,
    name: "provider-provider-information"
  }, {
    path: "/provider/selection",
    component: _d8c4ee7c,
    name: "provider-selection"
  }, {
    path: "/provider/success",
    component: _7fae5339,
    name: "provider-success"
  }, {
    path: "/provider/upload-document",
    component: _11a98ac6,
    name: "provider-upload-document"
  }, {
    path: "/provider/upload-documents",
    component: _1c308bb4,
    name: "provider-upload-documents"
  }, {
    path: "/",
    component: _4e67bcd9,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
